import clsx from 'clsx';

type TooltipBox = {
    children: string;
    icon?: React.ReactNode;
}

export default function TooltipBox({ children, icon }: TooltipBox) {
    return (
        <div
            className={clsx(
                'relative flex justify-center items-center',
                'min-h-20',
                'stele:min-h-80'
            )}
        >
            {icon &&
                <div
                    className={clsx(
                        'z-20 absolute text-white-stroke',
                        'w-20 h-20 -left-8.5',
                        'stele:w-80 stele:h-80 stele:-left-34'
                    )}
                >
                    {icon}
                </div>
            }
            <div className={clsx(
                'flex justify-center items-center bg-white-gradient drop-shadow-2-white-stroke-darker border-white-stroke-darker w-full pattern-background',
                'pr-4 pl-10 border-2 rounded-2xl min-h-12 max-w-[256px]',
                'stele:pr-16 stele:pl-40 stele:border-4 stele:rounded-[64px] stele:min-h-48 stele:max-w-5xl'
            )}>
                <p className={clsx(
                    'text-white-stroke-darker font-nunito font-bold leading-[135%] tracking-[-4%]',
                    'text-[12px]',
                    'stele:text-[40px]'
                )}>
                    {children}
                </p>
            </div>
        </div>
    )
}
